<template>
  <div
    :class="{
      'logged-user-wrapper fixed top-0 z-40 h-35px w-full bg-www-color-neutral-medium-dark': true,
      'md:flex': user,
      hidden: true,
    }"
  >
    <div
      :class="{
        'top-menu mx-auto h-full w-full max-w-1920px gap-6 px-5 lg:px-10': true,
        'items-center justify-end md:flex': true,
      }"
      data-testid="UtilityNavbar"
    >
      <LanguageSelector
        :class="{
          '-mr-22px': true,
        }"
      />
      <AiSearchBar :ai-advisor="aiAdvisor" />
      <div
        :class="{
          'welcome-auth-desktop px-2 text-10px font-bold text-www-color-white': true,
        }"
      >
        Welcome, {{ user?.firstName }}!
      </div>
      <LinkWithIcon
        _type="generalLink"
        :text="customerHome.text"
        :link="customerHome.link"
        icon-name="ptc-portal"
      />
      <LinkWithIcon
        _type="generalLink"
        :text="openOnshape.text"
        :link="openOnshape.link"
        icon-name="ptc-sign-in-arrow"
        :class="{
          'h-full bg-www-color-neutral-medium': true,
        }"
      />
    </div>
  </div>

  <div
    :class="{
      'anonymous-wrapper fixed top-0 z-40 h-35px w-full bg-www-color-neutral-medium-dark': true,
      'md:flex': !user,
      hidden: true,
    }"
  >
    <div
      :class="{
        'top-menu mx-auto h-full w-full max-w-1920px gap-5 px-5 lg:px-10': true,
        'items-center justify-end md:flex': true,
      }"
    >
      <LanguageSelector
        :class="{
          '-mr-18px': true,
        }"
      />
      <AiSearchBar :ai-advisor="aiAdvisor" />
      <LinkWithIcon
        _type="generalLink"
        :text="createStudentAccountButton.text"
        :link="createStudentAccountButton.link"
        icon-name="ptc-education"
        :class="{
          'h-full': true,
        }"
      />
      <LinkWithIcon
        _type="generalLink"
        :text="signinButton.text"
        :link="signinButton.link"
        icon-name="ptc-sign-in-arrow"
        :class="{
          '-mr-4 uppercase last-of-type:w-auto': true,
        }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { GeneralLink, HeaderAiAdvisor } from '~/sanity/types';
import AiSearchBar from '~/features/AiAdvisor/components/AiSearchBar.vue';
import LanguageSelector from '~/components/Molecules/UtitlityBarComponent/LanguageSelector.vue';
import LinkWithIcon from '~/components/Molecules/UtitlityBarComponent/LinkWithIcon.vue';
const { user, setParamsForFetch } = useCrossSession();
setParamsForFetch({ params: ['currentUserData'] });

defineProps<{
  createStudentAccountButton: GeneralLink;
  signinButton: GeneralLink;
  signupButton: GeneralLink;
  customerHome: GeneralLink;
  openOnshape: GeneralLink;
  aiAdvisor: HeaderAiAdvisor;
}>();
</script>
<style>
.top-menu .cta-button a span {
  display: flex;
  gap: 5px;
  align-items: center;
}

.lang_switcher_class .hover li a::after {
  border-bottom: 2px solid #40aa1d;
  content: '';
  display: block;
  left: 20%;
  position: absolute;
  top: 38px;
  width: 60%;
  z-index: 11;
}
</style>
